<template>
  <div class="container" ref="container">
    <div class="content">
      <h4>1. Generelt</h4>

      Stadssalg AS er et norsk selskap registrert i Brønnøysundregistrene med
      org.nr. 991 743 634 MVA. Vi er et avviklingsselskap som gjennom et
      auksjonssystem selger biler, kjøretøy, båter, maskiner, driftstilbehør,
      varelager og andre objekter på vegne av banker, finansieringsselskaper,
      inkassobyråer, konkursbo, namsmyndighetene – tvangssalg mv. <br /><br />
      Våre objekter er tilgjengelig på vår hjemmeside www.stadssalg.no og
      spørsmål om objekter eller budsystemet kan rettes til e-post
      sporsmal@stadssalg.no eller telefon 75 58 72 00. <br /><br />Alle objekter
      på vår hjemmeside og som befinner seg på våre lokasjoner selges på auksjon
      gjennom budrunder hvor vi ringer opp eller sender SMS til budgiver.
      <br /><br />
      Disse vilkår og auksjonsregler («Vilkårene») fastsetter rettigheter og
      plikter mellom den som oppretter en konto («Selger»), den som gir bud
      («Budgiver») og den som kjøper objektet («Kjøper»). I fellesskap omtalt
      som «Partene». Når Stadssalg selger objekter på kommisjon (på vegne av
      andre) vil Stadssalg være selger. Dette vil fremgå uttrykkelig av
      salgsdokumentasjonen. Partene er bundet av de vilkår som enhver tid
      gjelder, slik disse er gjort tilgjengelig på vår nettside.

      <h4 class="mt-5">2. Registrering</h4>

      For å kunne gjennomføre kjøp hos Stadssalg.no må du opprette en konto og
      bli registrert. For å opprette en brukerkonto må du registrere seg med
      navn, adresse, telefonnummer, e-postadresse. Når du legger inn et bud i
      våre systemer vil dette bli registrert og lagret knyttet til
      personopplysningene om deg. <br /><br />

      Du må være over 18 år og myndig for å kunne legge inn bud. Registeringen
      er vederlagsfri, men den registrerte plikter å besørge at alle
      opplysningene er korrekte og til enhver tid oppdatert. <br /><br />

      Opplysningene blir lagret på en sikker måte og ved gjennomført
      registrering aksepteres Vilkårene og du gir tillatelse til at Stadssalg
      benytter dine opplysninger i samsvar med vår Personvernerklæring. Denne
      finner du på vår nettside.<br /><br />

      Stadssalg forbeholder seg retten til å stenge kontoen ved brudd på
      vilkårene, herunder om brukeren ikke betaler kjøpesummen i tide eller ved
      annen uakseptabel adferd. Stadssalg forbeholder seg også retten til på
      utestenge brukere som bryter vilkårene, slette auksjoner og slette bud. En
      budgiver som får sin konto stengt, avsluttet eller suspendert kan ikke på
      ny opprette konto uten Stadssalg sitt samtykke.

      <h4 class="mt-5">3. Auksjonsregler - kjøp gjennom auksjonssystemet</h4>

      Alle bud inngitt i alle typer auksjoner er bindene for kontoinnehaver.
      Dette betyr at inngivelse av bud ikke kan tilbakekalles fra auksjonen når
      det er avgitt. <br /><br />

      Selger kan ikke selv legge inn bud på objekter Selger tilbyr eller gi
      andre i oppdrag å legge inn bud på slike objekter. <br /><br />

      Budrundene foregår ved at Stadssalg annonserer dato med tidspunkt for når
      objektet er klart for salg, og kontakter de som har gitt bud på objektet.
      Som budgiver får du informasjon om høyeste bud og du får da muligheten til
      å høyne eller å trekke deg ut av budrunden. Budgivere bør være tidlig med
      å registrere seg som budgiver på objektene selv om de ikke er klar for
      salg ettersom objektene selges samme dag som de blir klar gjennom budrunde
      med de som er registrert på objektet.<br /><br />

      Stadssalg forbeholder seg retten til å avslutte auksjoner, forlenge
      auksjoner, avlyse eller gjøre andre endringer hvor dette er nødvendig for
      at auksjonen skal kunne gjennomføres på betryggende måte eller dersom det
      fremkommer opplysninger som vil medføre uregelmessigheter av budprosessen,
      eller det foreligger nye opplysninger av betydning for budprosessen.
      <br /><br />

      Objekter som er merket «ikke klar» for salg på auksjon har tidsfrister som
      må overholdes. Klardato vil bli annonsert på objektet og alle budgivere
      kontaktes på eller snarest etter denne dato for bindende budrunde.
      <br /><br />

      Dersom objektet er merket «ikke klar» betyr det blant annet at
      dokumentasjon for sletting av pant, samt tidsfrister fra namsmannen/bank
      ikke er gått ut. Dette tar normalt mellom 3-5 uker fra objektet er lagt ut
      på våre nettsider. <br /><br />

      Etter endt budrunde skal høyeste bud godkjennes av oppdragsgiver eller
      forkastes. Selger og oppdragsgiver har rett til å avslå et hvert bud uten
      begrunnelse. Dette gjelder også høyeste bud og selv om minstepris er
      oppnådd. <br /><br />

      Når auksjon er avsluttet og vinnerbud akseptert anses avtale inngått. Det
      blir i tillegg inngått skriftlig avtale.

      <h4 class="mt-5">
        4. Betaling - merverdiavgift - omkostninger - heftelser - avhenting - mv
      </h4>

      <u>Betaling</u><br />
      Det avgis bekreftelse på at vinnerbud er akseptert og objektet betales
      innen 5 virkedager. Dersom betaling ikke finner sted innen fristen anses
      det å foreligge vesentlig mislighold av avtalen i henhold til Vilkårene,
      og selger har rett til å heve avtalen uten ytterligere varsel. Kjøper er
      ansvarlig for selgers eventuelle økonomiske tap i tillegg til
      avbruddsgebyr på 10% minimum kr 6.500,- maksimum kr 20.000,-<br /><br />

      <u>Merverdiavgift</u><br />
      Høyeste bud oppgis eksklusive merverdiavgift. Merverdiavgift på 25%
      tilkommer på objekter som er avgiftspliktige for eksempelvis maskiner,
      utstyr, driftstilbehør, varer mv. Kjøretøy mv. som ikke er avgiftspliktig
      selges uten merverdiavgift. Ved inngivelse av bud så vil du få opplyst
      samlet kostnad for budet, inkludert for eksempel merverdiavgift og
      administrasjonsgebyr. <br /><br />

      <u>Omkostninger</u><br />
      I tillegg til salgssummen kommer administrasjonsgebyr og eventuelle
      skyldige avgifter (klippegebyr, vekt, årsavgift, ikke tinglyste heftelser
      mv) Kjøper er selv ansvarlig for alle skyldige avgifter samt eventuell
      EU-godkjenning av motorvogner eller annen nødvendig tillatelse for bruk av
      objektet. I tillegg er ny eier ansvarlig for innbetaling av om
      registreringsavgift når eierskiftet er registrert hos Statens vegvesen.
      <br /><br />

      Administrasjonsgebyr som kommer i tillegg, vil fremkomme av annonsen og
      man vil få oppstilt dette før man inngir bud. <br /><br />

      <u>Heftelser</u><br />
      Heftelser registret i Brønnøysundregistrene vil bli sendt for sletting
      etter at salget er gjennomført. Slik sletting kan ta fra 1 – 8 uker.
      <br /><br />

      I tilfelle objektet er datamaskiner eller lignende og kjøper skulle finne
      data som er slettet før salg, forplikter kjøper seg til umiddelbart å
      slette disse data. Det vil kunne medføre erstatnings- og straffeansvar å
      benytte slike data urettmessig. <br /><br />

      <u>Avhenting og utlevering</u><br />
      Avhenting og utlevering/overlevering av objektet kan tidligst skje når
      kjøpesummen er registrert på konto hos Stadssalg og kjøpekontrakt er
      signert. <br /><br />

      Kjøper må bekoste alle utgifter vedrørende utlevering og frakt, henting
      mv. <br /><br />

      Fra avtalt overtakelsestidspunkt mellom kjøper og selger, har kjøper
      risikoen for objektet, og må selv besørge forsikring av objektet.
      <br /><br />

      Dersom et objekt ikke er hentet innen 5 virkedager etter at objektet er
      meldt klar for utlevering eller skriftlig avtalt frist, plikter kjøper å
      erstatte de kostnader Stadssalg blir påført for å søke, sikre og oppbevare
      objektet frem til kjøper avhenter. I et slikt tilfelle har ikke kjøper
      krav på å få objektet utlevert før eventuelle kostnader er betalt.
      <br /><br />

      Dette medfører ikke at Stadssalg AS har en plikt til å sikre og oppbevare
      uavhentede objekter. Ethvert tap, skade eller verdiforringelse av
      uavhentede objekter kan ikke lastes Stadssalg. Kjøper kan heller ikke
      fremme noen form for krav mot Stadssalg grunnet manglende sikring eller
      oppbevaring. Dersom Stadssalg allikevel sikrer og oppbevarer objektet så
      er kjøper pliktig å erstatte de kostnader dette medfører for Stadssalg som
      beskrevet over.

      <br /><br />

      Dersom et objekt ikke hentes innen 30 virkedager etter at objektet er
      meldt klar for utlevering eller skriftlig avtalt frist, anses dette som
      vesentlig mislighold av avtalen i henhold til disse vilkår, og selger har
      rett til å heve avtalen uten ytterligere varsel og foreta dekningssalg.
      Objektet blir lagt ut på ny auksjon og salgssummen vil gå til dekning av
      Stadssalgs kostnader herunder lagring, administrasjon mv. Dersom det blir
      overskudd ved dekningssalg etter fradrag for kostnader, vil dette tilfalle
      opprinnelig kjøper. Dersom det blir underdekning vil opprinnelig kjøper
      bli belastet tapet.

      <h4 class="mt-5">5. Reklamasjon - ansvar</h4>
      Alle objekter på Stadssalg.no selges som forevist uten garanti. Objektene
      blir lagt ut for salg og selges «som den er», «i stand den står» eller med
      lignende forbehold i medhold av kjøpsloven § 19 og forbrukerkjøpsloven §
      17. <br /><br />

      I forholdet mellom Kjøper og Selger gjelder også
      Forbrukerkjøpsloven/Kjøpsloven, som utfyller vilkårene, hvor annet ikke er
      presisert.<br /><br />

      Stadssalg gjennomfører også tvangssalg for namsfogden, i de tilfeller så
      er det reglene i tvangsfullbyrdelsesloven som gjelder.

      <br /><br />

      Det tas forbehold om at annonsen kan være mangelfull, varelister kan ha
      feil og mangler og det oppfordres til egne undersøkelser av de ulike
      salgsobjekter på våre lokasjoner. Alle henvisninger til årsmodell på
      stadssalg.no henviser til året objektet første gang ble registrert i Norge
      og samsvarer ikke nødvendigvis med årsmodell eller når objektet er
      produsert. Stadssalg AS tar ikke noe ansvar for eventuelle feil og mangler
      og dette vil ikke gi grunnlag for reklamasjon, heving eller på annen måte
      noen form for erstatning eller kompensasjon. Dette gjelder særlig objekter
      som selges uten tilstandsrapport eller lignende, herunder salg fra
      konkursbo, panthavere og hvor selger ikke har kunnskap om objektet, og
      hvor kjøper selv må gjøre nødvendige undersøkelser av objektet på angitt
      lokasjon før kjøper velger å inngi bud. <br /><br />

      Selger fraskriver seg så langt gjeldende rett tillater det ethvert ansvar
      tilknyttet salget, herunder for erstatningskrav, prisavslagskrav, samt
      øvrige misligholdsbeføyelser. <br /><br />

      For det tilfelle at kjøper inngir bud uten å ha besiktiget objektet, eller
      inngir bud på objektet «som det er» el., er dette kjøpes ansvar og risiko,
      og kjøper kan ikke fremme krav mot selger ettersom han ikke har gjort
      nødvendige undersøkelser av objektet før kjøper aksepterer objektet «som
      det er» ved inngivelse av bud. <br /><br />

      Det gjøres oppmerksom på at batteri og andre slitedeler som f.eks. bremser
      kan bli ødelagt/ruste i den tiden et objekt står hos Stadssalg uten at det
      er beskrevet i annonsen og dette er ikke noe som gir grunnlag for
      reklamasjon eller noe Stadssalg står ansvarlig for. <br /><br />

      Stadssalg gjør oppmerksom på at auksjonssalg fra våre lokasjoner ikke
      omfattes av angrerettloven og gir således ingen angrerett. <br /><br />

      Kjøpsavtalen og Vilkårene er underlagt norsk rett. <br /><br />

      Ved tvist med forbruker kan Forbrukerrådet som klageorgan behandle en
      tvist med en forbruker (se www.forbrukerradet.no).

      <h4 class="mt-5">6: Eksport - Export</h4>
      Stadssalg AS kan ikke garantere at all dokumentasjon som er nødvendig for
      eksportering foreligger. Vognkort og annen dokumentasjon kan mangle enten
      i sin helhet eller deler av den. Manglende dokumenter til eksport gir ikke
      grunnlag for å trekke sitt bud.
      <br /><br />
      Stadssalg AS cannot guarantee that all documents necessary for the export
      of objects is available or included in the purchase. All the documents or
      parts of it might be missing and as such not included. We remind our
      purchasers that all bids are final and missing export documents is not a
      valid basis for a withdrawal from the purchase.
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
